export const convertStringToSentenceCase = (value) => {
  const lower = typeof value === 'string' ? value.toLowerCase() : '';
  return lower && lower.charAt(0).toUpperCase() + lower.slice(1);
};
